import { IGameKeyHelp } from '~/rage';

export const playerKeysHelp: IGameKeyHelp[] = [
	{
		key: 'F7',
		icon: 'help',
	},
	{
		key: 'P',
		icon: 'report',
	},
	{
		key: 'F3',
		icon: 'car',
	},
	{
		key: 'R',
		icon: 'radial',
	},
	{
		key: 'T',
		icon: 'chat',
	},
	{
		key: 'Z',
		icon: 'mic',
	},
	{
		key: 'I',
		icon: 'inventory',
	},
	// {
	// 	key: 'ArrowDown',
	// 	icon: 'tablet',
	// },
	{
		key: 'ArrowUp',
		icon: 'phone',
	},
];

export const vehicleKeysHelp: IGameKeyHelp[] = [
	{
		key: 'F7',
		icon: 'help',
	},
	{
		key: 'P',
		icon: 'report',
	},
	{
		key: '1',
		icon: 'repair',
	},
	{
		key: '2',
		icon: 'engine',
	},
	{
		key: '3',
		icon: 'seatbelt',
	},
	{
		key: '4',
		icon: 'lock',
	},
	{
		key: 'Z',
		icon: 'mic',
	},
	{
		key: 'R',
		icon: 'radial',
	},
	// {
	// 	key: 'ArrowDown',
	// 	icon: 'tablet',
	// },
	{
		key: 'ArrowUp',
		icon: 'phone',
	},
];
